import { html, rune, type Html, View } from 'rune-ts';
import klass from './InterviewSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { staticTypoPcMo, typoPcMo } from '../../../../../shared/typography/typo';
import { map, pipe, toArray } from '@fxts/core';

interface InterviewCardProps {
  card_number: number;
}

const image_urls: Record<number, string> = {
  1: '//s3.marpple.co/files/u_4648126/2024/10/original/5554912b79b9db1b9953b9f474cbe876524264982.png',
  2: '//s3.marpple.co/files/u_4648126/2024/10/original/b966748700da37055a0bfe9f3bbd9d3cb93d228a3.png',
  3: '//s3.marpple.co/files/u_4648126/2024/10/original/a2763345b74fdff2de5cabdb8e3d01e4fc5e18a75.png',
};

const interview_card_tags: Record<number, string[]> = {
  1: ['LIFESTYLE', 'RESIN', 'HANDMADE'],
  2: ['LIFESTYLE', 'HOME DECO', 'HANDMADE'],
  3: ['LIFESTYLE', 'TEXTILE', 'HANDMADE'],
};

class InterViewCardTags extends View<InterviewCardProps> {
  override template({ card_number }: InterviewCardProps): Html {
    return html` <div class="${klass.tag_wrapper}">${this._renderTagList(card_number)}</div> `;
  }

  private _renderTagList(card_number: number) {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const card_tags = interview_card_tags[card_number] || [];
    return pipe(
      card_tags,
      map(
        (tag) => html`
          <div
            class="${klass.tag} 
                    ${staticTypoPcMo({
              is_mobile,
              pc: 'bebas_15_bold',
              mo: 'bebas_12_bold',
            })}"
          >
            ${tag}
          </div>
        `,
      ),
      toArray,
    );
  }
}

export class InterviewCard extends View<InterviewCardProps> {
  interViewCardTags: InterViewCardTags;

  constructor(data: InterviewCardProps) {
    super(data);
    this.interViewCardTags = new InterViewCardTags(data);
  }

  override template({ card_number }: InterviewCardProps) {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      creator: html.preventEscape(ET(`mps2::landing::handmade::interview_creator_${card_number}`)),
      sub_description: html.preventEscape(
        ET(`mps2::landing::handmade::interview_sub_description_${card_number}`),
      ),
      description: html.preventEscape(ET(`mps2::landing::handmade::interview_description_${card_number}`)),
    };

    return html`
      <div class="${klass.creator} ${is_mobile ? 'swiper-slide' : ''}">
        <div class="${klass.image_wrapper}">
          <img
            src="${getResizedUrl({
              url: image_urls[card_number] || '',
              width: is_mobile ? 384 * 2 : 300 * 2,
              quality: 85,
              format: 'webp',
            })}"
            alt="creator interview image"
          />
        </div>
        <div class="${klass.content}">
          <div class="${klass.title_wrapper}">
            ${this.interViewCardTags}
            <div
              class="${klass.title} 
                  ${typoPcMo({
                is_mobile,
                pc: '28_bold',
                mo: '20_bold',
              })}"
            >
              ${texts.creator}
            </div>
          </div>
          <div class="${klass.description_wrapper}">
            <div
              class="${klass.description} 
                  ${typoPcMo({
                is_mobile,
                pc: '16_medium',
                mo: '14_medium',
              })}"
            >
              ${texts.sub_description}
            </div>
            <div
              class="${klass.description} 
                  ${typoPcMo({
                is_mobile,
                pc: '16_medium',
                mo: '14_medium',
              })}"
            >
              ${texts.description}
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
